import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BookingService from "../../services/booking.service";

export const bookTravelPackage = createAsyncThunk(
  "booking/bookTravelPackage",
  async (payload, thunkAPI) => {
    try {
      const response= await BookingService.travelPackageBook(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Booking failed"
      );
    }
  }
);


export const bookWaterSports = createAsyncThunk(
  "booking/bookWaterSports",
  async (payload, thunkAPI) => {
    try {
      const response= await BookingService.waterSportsBook(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Booking failed"
      );
    }
  }
);

/* -------- VERIFY PAYMENT -------- */
export const verifyPayment = createAsyncThunk(
  "booking/verifyPayment",
  async (payload, thunkAPI) => {
    try {
     const response= await BookingService.verifyPayment(payload);
     return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Payment verification failed"
      );
    }
  }
);

/* -------- GET BOOKINGS -------- */
export const getBooking = createAsyncThunk(
  "booking/getBooking",
  async (payload, thunkAPI) => {
    try {
      const response= await BookingService.getBooking(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Failed to fetch bookings"
      );
    }
  }
);

const bookingSlice = createSlice({
  name: "booking",
  initialState: {
    /* history */
    data: [],          //  booking list
    page: 1,
    limit: 10,
    total: 0,

    /* states */
    isLoading: false,
    error: null,

    /* single booking / payment */
    booking: null,
    paymentVerified: false,
  },

  reducers: {
    clearBooking: (state) => {
      state.booking = null;
      state.paymentVerified = false;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ---- BOOK TRAVEL PACKAGE ---- */
      .addCase(bookTravelPackage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(bookTravelPackage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.booking = action.payload;
      })
      .addCase(bookTravelPackage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      /* ---- VERIFY PAYMENT ---- */
      .addCase(verifyPayment.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(verifyPayment.fulfilled, (state) => {
        state.isLoading = false;
        state.paymentVerified = true;
      })
      .addCase(verifyPayment.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      /* ---- GET BOOKING HISTORY ---- */
      .addCase(getBooking.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getBooking.fulfilled, (state, action) => {
        state.isLoading = false;

        //  IMPORTANT: extract array correctly
        state.data = action.payload.data || [];
        state.page = action.payload.page || 1;
        state.limit = action.payload.limit || 10;
        state.total = action.payload.total || 0;
      })
      .addCase(getBooking.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBooking } = bookingSlice.actions;
export default bookingSlice.reducer;
